// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3oV0G","savePackageButton":"ClientWallet_savePackageButton__3ucaP"};